export default "__VITE_ASSET__12df35d9__"